// service-form.tsx
import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { FormikProps } from "formik";
import Grid2 from "@mui/material/Grid2";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "src/utilities";
import { useAuth } from "src/context/auth";
import FollowupForm from "./followup-form";
import NeededPay from "./needed-pay";
import { ISystem } from "src/interface/ISystem";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { getRoutes } from "src/utilities/routes";

interface IServiceGroup {
  id: number;
  name: string;
}

const ServiceForm = ({ formik }: { formik: FormikProps<any> }) => {
  const { user } = useAuth();
  const Routes = getRoutes();

  const { data: System, isLoading: systemLoading } = useQuery({
    queryKey: ["SystemData1"],
    queryFn: () =>
      fetch(Routes.SystemsRoutes, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      }).then((res) => res.json()),
  });

  const { data: ServiceGroups, isLoading: serviceGroupsLoading } = useQuery({
    queryKey: ["ServiceGroupsData"],
    queryFn: () =>
      fetch(Routes.ServiceGroupsRoutes, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      }).then((res) => res.json()),
  });

  const [getSystem, setSystem] = React.useState<IAutoCompleteLabelValue[]>([]);
  const [getServiceGroups, setServiceGroups] = React.useState<
    IAutoCompleteLabelValue[]
  >([]);

  React.useEffect(() => {
    if (System) {
      setSystem(
        System.map((item: ISystem) => ({
          label: item.name,
          value: item.id,
        }))
      );
    }
  }, [System]);

  React.useEffect(() => {
    if (ServiceGroups) {
      setServiceGroups(
        ServiceGroups.map((item: IServiceGroup) => ({
          label: item.name,
          value: item.id,
        }))
      );
    }
  }, [ServiceGroups]);

  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={3}>
          <TextField
            {...formik.getFieldProps("rowId")}
            label="شماره ردیف"
            type="number"
            error={formik.touched.rowId && Boolean(formik.errors.rowId)}
            helperText={
              (formik.touched.rowId && formik.errors.rowId) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={5}>
          <TextField
            {...formik.getFieldProps("name")}
            label="نام خدمت"
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={(formik.touched.name && formik.errors.name) as boolean}
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={4}>
          <TextField
            {...formik.getFieldProps("price")}
            label="نرخ پایه"
            type="number"
            error={formik.touched.price && Boolean(formik.errors.price)}
            helperText={
              (formik.touched.price && formik.errors.price) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={7}>
          <Autocomplete
            value={
              getSystem.find((s) => s.value === formik.values.systemRef) || null
            }
            onChange={(event: any, newValue: any) => {
              formik.setFieldValue("systemRef", newValue?.value || undefined);
            }}
            loading={systemLoading}
            options={getSystem}
            fullWidth
            renderInput={(params) => (
              <TextField
                error={
                  formik.touched.systemRef && Boolean(formik.errors.systemRef)
                }
                helperText={
                  (formik.touched.systemRef &&
                    formik.errors.systemRef) as boolean
                }
                {...params}
                label="سامانه مرتبط"
                placeholder="سامانه مرتبط"
              />
            )}
          />
        </Grid2>
        <Grid2 size={5}>
          <Autocomplete
            value={
              getServiceGroups.find(
                (g) => g.value === formik.values.serviceGroupId
              ) || null
            }
            onChange={(event: any, newValue: any) => {
              formik.setFieldValue(
                "serviceGroupId",
                newValue?.value || undefined
              );
            }}
            loading={serviceGroupsLoading}
            options={getServiceGroups}
            fullWidth
            renderInput={(params) => (
              <TextField
                error={
                  formik.touched.serviceGroupId &&
                  Boolean(formik.errors.serviceGroupId)
                }
                helperText={
                  (formik.touched.serviceGroupId &&
                    formik.errors.serviceGroupId) as boolean
                }
                {...params}
                label="گروه خدمات"
                placeholder="گروه خدمات"
              />
            )}
          />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={1} marginBottom={1}>
        <Grid2 size={12}>
          <FollowupForm formik={formik} />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={1} marginBottom={1}>
        <Grid2 size={12}>
          <NeededPay formik={formik} />
        </Grid2>
      </Grid2>
    </>
  );
};

export default ServiceForm;
